import { gql, useQuery } from '@apollo/client'

export interface IQueryDataType {
  listGlCodes: {
    nodes: {
      code: string
      displayOrder: number
      id: string
      name: string
      parentGroupId: string
      sortingPreference: 'ASC' | 'DESC'
    }[]
  }
  listGlGroups: {
    nodes: {
      displayOrder: number
      exrayCategory: string
      id: string
      name: string
      displayName: string
      parentGroupId: string
      sortingPreference: 'ASC' | 'DESC'
      formula: Record<string, unknown>
    }[]
  }
}

const query = gql`
  query ListGlCodesAndGroups {
    listGlCodes {
      nodes {
        id
        code
        name
        parentGroupId
        displayOrder
        sortingPreference
      }
    }

    listGlGroups {
      nodes {
        id
        name
        displayName
        parentGroupId
        displayOrder
        exrayCategory
        sortingPreference
        formula
      }
    }
  }
`

const useListGlCodesAndGroups = () => {
  return useQuery<IQueryDataType>(query)
}

export default useListGlCodesAndGroups
